import {
    ADD_FILE,
    CLEAR_FILES,
    REMOVE_FILE,
    UPDATE_FILE
} from "@/store/mutations.type"

export default {
    [ADD_FILE](state, photo) {
        state.photos.push(photo)
    },

    [REMOVE_FILE](state, photoId) {
        state.photos.splice(state.photos.findIndex(photo => photo.id === photoId), 1)
    },

    [UPDATE_FILE](state, payload) {
        const photo = state.photos.find(photo => photo.id === payload.id)
        Object.assign(photo, payload.values)
    },
    
    [CLEAR_FILES](state, type) {
        for( let i = 0; i < state.photos.length; i++) {
            if (state.photos[i].type === type) {
                state.photos.splice(i, 1)
                i--
            }
        }
    }
}